// extracted by mini-css-extract-plugin
export var smallSpinner = "_qm-0";